import { createRoute, lazyRouteComponent, stripSearchParams } from '@tanstack/react-router'
import type { RegistrationRequestStatus } from '@volee/api-client'

import { requireBackoffice } from '../auth/guard.ts'
import { REGISTRATION_REQUEST_STATUS_ORDER } from '../messages/index.ts'
import { parseOneOf, parsePage } from './params.ts'
import { rootRoute } from './root.tsx'

// The sign-up queue, a tab of the incarichi: approving a request writes one. Filter and page are typed search params (§4.4), so «le richieste che
// aspettano un'integrazione» is a link an operator can send to a colleague.

export interface RegistrationSearch {
  /** 1-based: it is the number a person shares. */
  readonly page: number
  readonly status: RegistrationRequestStatus | null
}

// From the ordering and not from a label map: key order in a catalogue is a translation
// detail, and the two locales are free to diverge on it.
const STATUSES = REGISTRATION_REQUEST_STATUS_ORDER

export const DEFAULT_REGISTRATION_SEARCH: RegistrationSearch = {
  page: 1,
  status: null,
}

export function parseRegistrationRequestStatus(value: unknown): RegistrationRequestStatus | null {
  return parseOneOf(STATUSES, value)
}

/** The queue as a link target: path and the search params its type requires, in one place. */
export const registrationListLink = {
  to: '/appointments/requests',
  search: DEFAULT_REGISTRATION_SEARCH,
} as const

export function validateRegistrationSearch(search: Record<string, unknown>): RegistrationSearch {
  return {
    page: parsePage(search.page),
    status: parseRegistrationRequestStatus(search.status),
  }
}

export const registrationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/appointments/requests',
  validateSearch: validateRegistrationSearch,
  search: {
    // Defaults leave the URL: a colleague receives /appointments/requests?status=submitted.
    middlewares: [stripSearchParams(DEFAULT_REGISTRATION_SEARCH)],
  },
  // Runs before the component is fetched: without the role, no chunk downloads.
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/registrations.tsx')),
})
